import { render, staticRenderFns } from "./OrganizationChart.vue?vue&type=template&id=5525da57&"
import script from "./OrganizationChart.vue?vue&type=script&lang=js&"
export * from "./OrganizationChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports